// src/redux/slices/filtersSlice.js
import { createSlice } from "@reduxjs/toolkit";

// ── Utility ────────────────────────────────────────────────────
const formatDate = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${year}-${month}-${day}`;
};

// ── Default Date Range (Last 7 days) ───────────────────────────
const today = new Date();
const lastWeek = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);

// ── Initial State ──────────────────────────────────────────────
const initialState = {
  // Date filters (was dateSlice)
  startDate: formatDate(lastWeek),
  endDate: formatDate(today),
  period: "lastWeek",

  // User group filter (was userGroupSlice)
  userGroup: "all", // "all" | "amgen" | "pace"

  // Agent filters (was tableSlice — renamed for clarity)
  businessUnit: "Global",
  agentName: "",
  subAgentName: [],
  selectedEmails: [],
};

// ── Slice ──────────────────────────────────────────────────────
const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    // Was setDates in dateSlice
    setDates: (state, action) => {
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
      state.period = action.payload.period;
    },

    // Was setUserGroup in userGroupSlice
    setUserGroup: (state, action) => {
      state.userGroup = action.payload;
    },

    // Was setBusinessUnit in tableSlice
    setBusinessUnit: (state, action) => {
      state.businessUnit = action.payload;
    },

    // Was setAgentName in tableSlice
    setAgentName: (state, action) => {
      state.agentName = action.payload;
    },

    // Was setSubAgentName in tableSlice
    setSubAgentName: (state, action) => {
      state.subAgentName = action.payload;
    },

    // Was setAgentAndSubAgent in tableSlice
    setAgentAndSubAgent: (state, action) => {
      state.agentName = action.payload.agentName;
      state.subAgentName = action.payload.subAgentName;
    },

    setSelectedEmails: (state, action) => {
      state.selectedEmails = action.payload;
    },

    // Bonus — reset all filters to default in one shot
    resetFilters: () => initialState,
  },
});

export const {
  setDates,
  setUserGroup,
  setBusinessUnit,
  setAgentName,
  setSubAgentName,
  setAgentAndSubAgent,
  setSelectedEmails,
  resetFilters,
} = filtersSlice.actions;

export default filtersSlice.reducer;
